export const app_name = 'Essay Grading Software';
export const app_name_id = 'essay-grading-software';
export const project_path = 'https://github.com/shc0743/essay-grading-software';
export const AGREEMENT_VERSION = '20251018.1';
export const PROMPT_FILES: { [key: string]: number } = { 'ocr-generic': 1, 'ocr-essay-english': 1, 'ocr-paper-question': 1, 'essay-grade-english': 2 };
